<template>
    <div class="wrap-content-btn-expand">
        <div class="btn-expand p-y-20" :class="{ position_mid: isBtnCenter }">
            <button type="button" class="btn p-0 btn-link" :id="id" @click="toogleExpand">
                <img
                    src="@/assets/icons/chevron-rotate-down.svg"
                    :class="{ rotate_icon_180: isExpand, rotate_icon_0: !isExpand }"
                />
                <span class="f-16 f-semi f-c-blue p-l-8">{{ text }}</span>
            </button>
        </div>
        <div class="content" :id="`${id}-content`" v-if="isHasExpand" :class="{ show: isExpand }">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "SOButtonExpand",
    props: {
        text: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        isBtnCenter: {
            type: Boolean,
            default: true,
        },
        fullHeight: {
            type: Number,
        },
    },
    data() {
        return {
            isExpand: false,
        };
    },
    watch: {
        isExpand: function(newVal, oldVal) {
            let elHeight = this.fullHeight ? `${this.fullHeight}px` : `100%`;
            elHeight = newVal ? elHeight : "0px";

            document.getElementById(`${this.id}-content`).style.height = elHeight;
            if (newVal !== oldVal) {
                setTimeout(() => {
                  this.setVisible();
                }, newVal ? 200 : 0);
            }
        },
    },
    computed: {
        isHasExpand() {
            return !!this.$slots.content;
        },
    },
    methods: {
        setExpand(val) {
            this.isExpand = val;
        },
        toogleExpand() {
            this.isExpand = !this.isExpand;
        },
        setVisible() {
          let content = document.getElementById(`${this.id}-content`);
          let elHeight = this.fullHeight ? `${this.fullHeight}px` : `100%`;
          if (elHeight === content.style.height) {
            document.getElementById(`${this.id}-content`).style.overflow = "visible";
          } else {
            document.getElementById(`${this.id}-content`).style.overflow = "hidden";
          }
        },
    },
};
</script>
<style scoped>
.wrap-content-btn-expand {
    position: relative;
}

.wrap-content-btn-expand .position_mid {
    text-align: center;
}

.wrap-content-btn-expand .rotate_icon_180 {
    transform: rotate(180deg);
    transition-duration: 300ms;
}

.wrap-content-btn-expand .rotate_icon_0 {
    transform: rotate(0deg);
    transition-duration: 300ms;
}
.wrap-content-btn-expand .content {
    height: 0px;
    transition: height 0.2s ease-out;
    overflow: hidden;
}
.wrap-content-btn-expand .content.show {
    transition: height 0.2s ease-in;
    overflow: visible;
}
</style>
